<template>
  <v-container fluid class="actionHeader">
    <span
      v-if="!(this.component.name != 'NFSE' &&this.component.name != 'CTE' && this.component.name != 'NFeRecebidas')"
    >
      <v-flex xs12>
        <v-layout class="space_header" align-center justify-space-between row fill-height>
          <div id="c-margin-space-left" class="headerDiv">
            <btnUpload :component="component" :empresa="empresa" :table="table"></btnUpload>

            <btnConsultaAvulsa
              v-if="component.enable.consultaSefaz  && component.name !== 'NFeRecebidas' && empresa.servicos && empresa.servicos.robotizacao && !empresa.servicos.robotizacao.find(item => item.nomeServico === 'NFSE_TOMADOS')"
              :conta="conta"
              :logQtd="this.logQtd"
              :logConsulta="this.logConsulta"
              :range="this.range"
              @getLogConsulta="getLogConsulta($event)"
              :empresa="empresa"
              :table="table"
              :component="component"
            ></btnConsultaAvulsa>

            <btnNovaNota
              v-if="component.name === 'NFSE' && component.tipo === 'emitida'  && empresa.servicos && empresa.servicos.robotizacao && empresa.servicos.robotizacao.find(item => item.nomeServico === 'NFSE_TOMADOS')"
              :conta="conta"
              :empresa="empresa"
              :table="table"
              :component="component"
              :edit="false"
            ></btnNovaNota>

            <btnUploadPlanilha
              v-if="component.name === 'NFSE' && empresa.servicos && empresa.servicos.robotizacao && empresa.servicos.robotizacao.find(item => item.nomeServico === 'NFSE_TOMADOS')"
              :conta="conta"
              :empresa="empresa"
              :table="table"
              :component="component"
              :alert="alert"
            ></btnUploadPlanilha>
            <BtnEnviaFtp
              v-if="component.name === 'NFeRecebidas' && empresa.servicos && empresa.servicos.ftp && empresa.servicos.ftp.botao_envio == true"
              :component="component"
              :arraySelect="this.table.selected"
              :empresa="empresa"
              :table="table"
              :conta="conta"
            ></BtnEnviaFtp>

            <btnColumns
              v-if="component.enable.colunas"
              :conta="this.conta"
              :empresa="empresa"
              :component="this.component"
              :headers="headers"
              :table="table"
              @getHeader="getHeader($event)"
            ></btnColumns>

            <btnExpExcell
              v-if="component.enable.expExcel"
              :component="this.component"
              :table="this.table"
              :nfseErros="false"
              :nfseDes="false"
            ></btnExpExcell>
            <btnImportadorXml
            v-if="component.name === 'NFeRecebidas' && empresa.servicos && empresa.servicos.robotizacao && empresa.servicos.robotizacao.find(item => item.nomeServico === 'IMPORTADOR_XML_MANUAL')"
              :component="component"
              :arraySelect="this.table.selected"
              :empresa="empresa"
              :table="table"
              :conta="conta"
              @getSelected="getSelected($event)"
            ></btnImportadorXml>
          </div>
          <div style="margin-bottom: 21px">
          <btnDias
            :buttons="this.table.rangeButtons"
            :component="component"
            :table="this.table"
            :empresa="this.empresa"
            :conta="this.conta"
            :openFiltro="this.openFiltro"
            @getDataBusca="getDataBusca($event)"
            @getOpenFiltro="getOpenFiltro($event)"
          ></btnDias>
          </div>
        </v-layout>
      </v-flex>
      <v-flex xs12>
        <v-layout class="space_header" align-center justify-space-between row fill-height>
          <div id="c-margin-space-left" class="headerDiv">
            <btnUploadPlanilhaEscrituracao
              v-if="component.name === 'NFSE' && empresa.servicos && empresa.servicos.escrituracaoNfse && empresa.servicos.escrituracaoNfse.uploadBotaoNfse === true"
              :conta="conta"
              :empresa="empresa"
              :table="table"
              :component="component"
              :alert="alert"
            ></btnUploadPlanilhaEscrituracao>
            <btnSelectAll
              v-if="component.enable.selectAll"
              :selected="selected"
              :table="table"
              @getSelected="getSelected($event)"
            ></btnSelectAll>
            <BtnEnviaFluig
              v-if="(component.name === 'CTE' || component.name === 'NFeRecebidas' || component.name === 'NFSE') && empresa.servicos && empresa.servicos.fluig && empresa.servicos.fluig.botao_envio == true"
              :component="component"
              :arraySelect="this.table.selected"
              :empresa="empresa"
              :table="table"
              :conta="conta"
            ></BtnEnviaFluig>
            <btnDownload
              :component="component"
              :arraySelect="this.table.selected"
              :empresa="empresa"
              :table="table"
              :conta="conta"
            ></btnDownload>
            <btnEmail
              v-if="this.component.enable.selectAll && this.component.enable.envEmail"
              style="display: inline-block;"
              :id_nota="getIdSelecteds"
              :conta="this.conta"
              :table="this.table"
              :component="this.component"
              :zip="true"
              :empresa="this.empresa"
            ></btnEmail>
          </div>
          <div>
            <!-- v-if="!(this.component.name != 'NFSE' &&this.component.name != 'CTE' && this.component.name != 'NFeRecebidas')"  -->
            <v-flex flex xs12 sm3 md3 lg4 text-xs-center d-flex id="search" class="searchBtn">
              <v-select
                v-if="component.enable.search"
                class="filtroForSearch"
                persistent-hint
                :items="filterItensSearch()"
                return-object
                item-disabled="search"
                no-data-text="Sem valores"
                :menu-props="{nudgeBottom:20}"
                background-color="teal"
                color="teal"
                solo
                v-model="filtroForSearch"
                :change="getSearchTag"
              ></v-select>
              <v-text-field
                class="fieldSearch"
                v-model="search"
                append-icon="search"
                :label="`Pesquisar em ${filtroForSearch.text}`"
                solo
                hide-details
                @input="emitFiltro($event)"
              ></v-text-field>
            </v-flex>
          </div>
        </v-layout>
      </v-flex>
    </span>
    <span v-else>
      <v-flex xs12>
        <v-layout class="space_header" align-center justify-space-between row fill-height>
          <div id="c-margin-space-left">
            <btnColumns
              v-if="component.enable.colunas"
              :conta="this.conta"
              :empresa="empresa"
              :component="this.component"
              :headers="headers"
              :table="table"
              @getHeader="getHeader($event)"
            ></btnColumns>

            <btnExpExcell
              v-if="component.enable.expExcel"
              :component="this.component"
              :table="this.table"
              :nfseErros="false"
              :nfseDes="false"
            ></btnExpExcell>

            <btnSelectAll
              v-if="component.enable.selectAll"
              :selected="selected"
              :table="table"
              @getSelected="getSelected($event)"
            ></btnSelectAll>
            <btnDownload
              :component="component"
              :arraySelect="this.table.selected"
              :empresa="empresa"
              :table="table"
              :conta="conta"
            ></btnDownload>
            <btnEmail
              v-if="this.component.enable.selectAll && this.component.enable.envEmail"
              style="display: inline-block;"
              :id_nota="getIdSelecteds"
              :conta="this.conta"
              :table="this.table"
              :component="this.component"
              :zip="true"
              :empresa="this.empresa"
            ></btnEmail>
          </div>
          <div>
            <!-- v-if="!(this.component.name != 'NFSE' &&this.component.name != 'CTE' && this.component.name != 'NFeRecebidas')"  -->
            <v-flex flex xs12 sm3 md3 lg4 text-xs-center d-flex id="search" class="searchNBtn">
              <v-select
                v-if="component.enable.search"
                class="filtroForSearch"
                persistent-hint
                :items="filterItensSearch()"
                return-object
                item-disabled="search"
                no-data-text="Sem valores"
                :menu-props="{nudgeBottom:20}"
                background-color="teal"
                color="teal"
                solo
                v-model="filtroForSearch"
                :change="getSearchTag"
              ></v-select>
              <v-text-field
                class="fieldSearch"
                v-model="search"
                append-icon="search"
                :label="`Pesquisar em ${filtroForSearch.text}`"
                solo
                hide-details
                @input="emitFiltro($event)"
              ></v-text-field>
            </v-flex>
          </div>
        </v-layout>
      </v-flex>
    </span>
  </v-container>
</template>
<script>
import btnDias from "./btnDias/BtnDias.vue";
import btnConsultaAvulsa from "./btnConsultaAvulsa/BtnConsultaAvulsa";
import btnColumns from "./btnColumn/BtnColumn";
import btnExpExcell from "./btnExpExcell/BtnExpExcell.vue";
import btnSelectAll from "./btnSelectAll/btnSelectAll.vue";
import btnEmail from "@/components/dataTable/commonTable/coluna_actions/btnEmail/BtnEmail.vue";
import btnUpload from "@/components/dataTable/commonTable/actionsHeader/btnUpload/BtnUpload.vue";
import btnDownload from "@/components/dataTable/commonTable/actionsHeader/btnDownload/BtnDownload.vue";
import btnImportadorXml from "@/components/dataTable/commonTable/actionsHeader/btnImportadorXml/BtnImportadorXml.vue";
import btnNovaNota from "@/components/dataTable/commonTable/actionsHeader/btnNovaNota/BtnNovaNota.vue";
import btnUploadPlanilha from "@/components/dataTable/commonTable/actionsHeader/btnUploadPlanilha/BtnUploadPlanilha.vue";
import btnUploadPlanilhaEscrituracao from "@/components/dataTable/commonTable/actionsHeader/btnUploadPlanilha/BtnUploadPlanilhaEscrituracao.vue";
import BtnEnviaFtp from "@/components/dataTable/commonTable/actionsHeader/btnEnviaFtp/BtnEnviaFtp.vue";
import BtnEnviaFluig from "@/components/dataTable/commonTable/actionsHeader/btnEnviaFluig/BtnEnviaFluig.vue";
export default {
  props: [
    "headers",
    "table",
    "selected",
    "empresa",
    "component",
    "range",
    "logConsulta",
    "logQtd",
    "conta",
    "openFiltro",
    "alert"
  ],
  components: {
    btnConsultaAvulsa: btnConsultaAvulsa,
    btnColumns: btnColumns,
    btnExpExcell: btnExpExcell,
    btnSelectAll: btnSelectAll,
    btnDias: btnDias,
    btnEmail: btnEmail,
    btnDownload: btnDownload,
    btnImportadorXml: btnImportadorXml,
    btnUpload: btnUpload,
    btnNovaNota,
    btnUploadPlanilha,
    btnUploadPlanilhaEscrituracao,
    BtnEnviaFluig,
    BtnEnviaFtp
},
  data: () => ({
    search: "",
    filtroForSearch: { text: "Tudo", value: "tudo" }
  }),
  watch: {
    table() {}
  },
  methods: {
    getHeader: function($event) {
      this.$emit("getHeader", $event);
    },
    getSelected($event) {
      let selected = $event;
      this.$emit("updatedSelected", selected);
    },
    emitFiltro($event) {
      this.$emit("getSearch", $event);
    },
    getOpenFiltro($event) {
      this.$emit("getOpenFiltro", $event);
    },
    getLogConsulta($event) {
      this.$emit("getLogConsulta", $event);
    },
    getDataBusca: function($event) {
      this.$emit("getDataBusca", $event);
    },
    filterItensSearch() {
      let array = [{ text: "Tudo", value: "tudo" }];
      this.table.headers.forEach(function(item) {
        if (item.pesq) {
          array.push(item);
        }
      });
      return array.sort(function(a, b) {
        if (a > b) return -1;
        else return 1;
      });
    },
  },
  computed: {
    getSearchTag() {
      this.$emit("tagForSearch", this.filtroForSearch);
    },
    getIdSelecteds: function() {
      let array = [];
      this.table.selected.filter(v => array.push(v._id));
      return array;
    }
  }
};
</script>
<style scoped>
.headerDiv {
  display: flex;
  align-items: center;
}
</style>




// WEBPACK FOOTER //
// src/components/dataTable/commonTable/actionsHeader/ActionsHeader.vue